import { useEffect, useState } from "react";
import { BarChart3, Loader2, TrendingUp, Smartphone, Monitor } from "lucide-react";
import api from "@/lib/api";

export default function AdminInsights() {
  const [d, setD] = useState(null);
  const [denied, setDenied] = useState(false);
  useEffect(() => { api.get("/admin/analytics/platform").then((r) => setD(r.data)).catch((e) => { if (e.response?.status === 403) setDenied(true); }); }, []);

  if (denied) return <p className="text-sm text-[#71717A]" data-testid="admin-insights-denied">Access denied.</p>;
  if (!d) return <div className="flex justify-center py-20 text-[#71717A]"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  const dev = d.devices; const devTotal = (dev.mobile + dev.desktop) || 1;

  return (
    <div data-testid="admin-insights" className="space-y-8">
      {/* Retention */}
      <div>
        <div className="flex items-center gap-2 mb-3"><TrendingUp className="w-5 h-5 text-[#D4AF37]" /><h3 className="text-white font-medium">User retention</h3></div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="rounded-2xl border border-white/8 bg-[#121214] p-5" data-testid="ins-active-7d"><div className="font-heading text-2xl text-white">{d.retention.active_7d.toLocaleString()}</div><div className="text-xs text-[#71717A]">Active last 7 days ({d.retention.retention_7d}%)</div></div>
          <div className="rounded-2xl border border-white/8 bg-[#121214] p-5" data-testid="ins-active-30d"><div className="font-heading text-2xl text-white">{d.retention.active_30d.toLocaleString()}</div><div className="text-xs text-[#71717A]">Active last 30 days ({d.retention.retention_30d}%)</div></div>
          <div className="rounded-2xl border border-white/8 bg-[#121214] p-5" data-testid="ins-total"><div className="font-heading text-2xl text-white">{d.retention.total_users.toLocaleString()}</div><div className="text-xs text-[#71717A]">Total users</div></div>
        </div>
      </div>

      {/* Feature adoption */}
      <div>
        <h3 className="text-white font-medium mb-3">Feature adoption</h3>
        <div className="space-y-3" data-testid="ins-adoption">
          {d.feature_adoption.map((f) => (
            <div key={f.feature}>
              <div className="flex justify-between text-sm mb-1"><span className="text-[#D4D4D8]">{f.feature}</span><span className="text-[#71717A]">{f.users.toLocaleString()} · {f.pct}%</span></div>
              <div className="h-2 rounded-full bg-white/5 overflow-hidden"><div className="h-full fv-gold-gradient" style={{ width: `${Math.min(f.pct, 100)}%` }} /></div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Module usage */}
        <div>
          <div className="flex items-center gap-2 mb-3"><BarChart3 className="w-5 h-5 text-[#D4AF37]" /><h3 className="text-white font-medium">Most used modules</h3></div>
          <div className="rounded-2xl border border-white/8 bg-[#121214] divide-y divide-white/5" data-testid="ins-modules">
            {d.module_usage.most_used.map((m) => (
              <div key={m.module} className="flex items-center justify-between px-5 py-3"><span className="text-[#D4D4D8] capitalize">{m.module}</span><span className="text-[#D4AF37] text-sm">{m.count.toLocaleString()}</span></div>
            ))}
          </div>
        </div>

        {/* Devices */}
        <div>
          <h3 className="text-white font-medium mb-3">Device distribution</h3>
          <div className="rounded-2xl border border-white/8 bg-[#121214] p-5 space-y-4" data-testid="ins-devices">
            {[["Desktop", dev.desktop, Monitor], ["Mobile", dev.mobile, Smartphone]].map(([label, n, Icon]) => (
              <div key={label}>
                <div className="flex justify-between text-sm mb-1"><span className="text-[#D4D4D8] flex items-center gap-2"><Icon className="w-4 h-4 text-[#D4AF37]" />{label}</span><span className="text-[#71717A]">{Math.round((n / devTotal) * 100)}%</span></div>
                <div className="h-2 rounded-full bg-white/5 overflow-hidden"><div className="h-full fv-gold-gradient" style={{ width: `${(n / devTotal) * 100}%` }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
